import React from "react";
import { ApolloConsumer } from "@apollo/client";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { setInitializeApplication } from "./action";
import Util from "../../global/utils/Helpers";
import isDeveloper from "../SimpleForm/SubmissionUtilities/isDeveloper";
import { GET_APPLICATION_ID } from "../Forms/genericQueries";
import FormButtonContainer from "./FormButtonContainer";
import allowReuse from "../SimpleForm/CaseReuse/allowReuse";

const renderOldApplicationButton = (index, form, props) => {
  const { name, label, form_type, available_date } = form;

  const { dispatch, user } = props;
  const { Roles } = props.user;

  return (
    <FormButtonContainer
      key={index}
      disabled={Util.isDisabled(available_date, Roles)}
      onClick={() => {
        dispatch(
          setInitializeApplication({
            user: user,
            application: form_type,
          })
        );
      }}
    >
      <>
        <p className="usa-link">{name}</p>
        <p>{label}</p>
      </>
    </FormButtonContainer>
  );
};

const renderSimpleFormApplicationButton = (
  index,
  form,
  props,
  toggleReuse,
  toggleDetermineVersionModal,
  setReuseParameters,
  multiVersion,
  setIsReusable,
  user
) => {
  const { name, label, form_type, reuse } = form;

  const { Roles, FormStatus } = user;

  const isDeveloperRole = isDeveloper(Roles);
  const isReusable = allowReuse(FormStatus, form_type);

  let disabled = false;
  if (form_type === "790A" || form_type === "9142A") {
    if (
      FormStatus &&
      FormStatus[0] &&
      !FormStatus[0].prefill &&
      !isDeveloperRole
    ) {
      disabled = true;
    }
  } else if (form_type === "9035") {
    if (
      FormStatus &&
      FormStatus[1] &&
      !FormStatus[1].prefill &&
      !isDeveloperRole
    ) {
      disabled = true;
    }
  }
  return (
    <ApolloConsumer key={index}>
      {(client) => {
        const openForm = async (
          initialValues,
          version = null,
          reuseMetadata = null
        ) => {
          // Rolling back V3 H2A and disabling modal
          if (form_type === "790A" || form_type === "9142A") {
            version = 2;
          }
          const { data } = await client.mutate({
            mutation: GET_APPLICATION_ID,
            variables: {
              group_id: user.Group.id,
              FormType: form_type,
              formVersionId: version,
              reuseMetadata,
              modalAnswer:
                version && version <= 2
                  ? "Yes"
                  : !!version && version === 3
                  ? "No"
                  : null,
            },
            pollInterval: 0,
          });

          const app_id = data.addForm;

          let state = {};
          let formVersionPathSegment = "";
          if (!!initialValues) {
            state = { initialValues, reuse: true };
          }
          if (!!version) {
            formVersionPathSegment = `/V${version}`;
          }

          if (!!initialValues && "target" in initialValues) {
            return props.history.push(
              `/dashboard/application/${form_type}/${app_id}${formVersionPathSegment}`
            );
          } else {
            return props.history.push({
              pathname: `/dashboard/application/${form_type}/${app_id}${formVersionPathSegment}`,
              state,
            });
          }
        };

        const queryParameters = {
          form_id: form_type,
          user_id: user.subject,
          group_id: user.Group ? user.Group.id : null,
          group_role: user.GroupRole || null,
        };

        return (
          <FormButtonContainer
            onClick={
              !reuse && !isReusable && !multiVersion // isReusable is for a new reuse functionality and permission is received from graphql. Toggled by setting env variables
                ? openForm
                : !!multiVersion
                ? () => {
                    setIsReusable(form_type === "790A");
                    toggleDetermineVersionModal();
                    setReuseParameters(form_type, openForm, queryParameters);
                  }
                : () => {
                    toggleReuse();
                    setReuseParameters(form_type, openForm, queryParameters);
                  }
            }
            disabled={disabled}
          >
            <>
              <p className="usa-link">
                <a className="usa-link" href="#">
                  {name}
                </a>
              </p>
              <p>{label}</p>
            </>
          </FormButtonContainer>
        );
      }}
    </ApolloConsumer>
  );
};

const renderSimpleFormWithoutBackend = (index, application_type, props) => {
  return (
    <button
      key={index}
      className={"usa-button application-button"}
      onClick={() => {
        return props.history.push(
          `/dashboard/application/${application_type}/aniceidwillgohere`
        );
      }}
    >
      Create New{" "}
    </button>
  );
};

const FormButtons = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.appReducer.userDataReducer.data);
  const {
    forms,
    toggleReuse,
    toggleDetermineVersionModal,
    setReuseParameters,
    multiVersion,
    setIsReusable,
  } = props;
  return forms.map((form, index) => {
    if (form.simpleForm && form.backendReady !== false) {
      return renderSimpleFormApplicationButton(
        index,
        form,
        props,
        toggleReuse,
        toggleDetermineVersionModal,
        setReuseParameters,
        multiVersion,
        setIsReusable,
        user
      );
    } else if (form.simpleForm) {
      return renderSimpleFormWithoutBackend(index, form, props);
    } else {
      // REFACTOR: Dead code, should remove later
      return renderOldApplicationButton(index, form, props);
    }
  });
};

export default withRouter(FormButtons);
